import {
    ccClosedCaptionOn,
    ccClosedCaptionOff,
    ccTalkingGuideOn,
    ccTalkingGuideOff
} from '@/assets/icons/ccIconsSvg';

export default {
    building: 'apartment',
    wing: 'airplanemode_active',
    floor: 'clear_all',
    room: 'meeting_room',
    serviceAccount: 'event_note',
    device: 'router',
    defaultItem: 'insert_photo',
    moreItems: 'more_horiz',
    moreItemsVert: 'more_vert',
    dashboard: 'developer_board',
    space: 'apartment',
    deviceStatus: 'speaker_phone',
    tag: 'local_offer',
    users: 'people',
    settings: 'settings_applications',
    activity: 'list_alt',
    switchVenue: 'swap_horizontal_circle',
    role: 'supervised_user_circle',
    support: 'room_service',
    defaultNav: 'menu_open',
    edit: 'edit',
    email: 'email',
    resetDevice: 'settings_remote',
    viewItem: 'library_books',
    user: 'person',
    refresh: 'refresh',
    logout: 'logout',
    login: 'mdi-login',
    arrowBack: 'arrow_back',
    arrowForward: 'arrow_forward_ios',
    arrowRight: 'keyboard_arrow_right',
    college: 'school',
    business: 'business',
    darkMode: 'invert_colors',
    bugReport: 'bug_report',
    touch: 'touch_app',
    viewList: 'view_list',
    viewTree: 'account_tree',
    alert: 'notification_important',
    close: 'close',
    download: 'save_alt',
    history: 'history',
    check: 'check',
    delete: 'delete',
    reset: 'settings_backup_restore',
    checkin: 'check_box',
    checkout: 'check_box_outline_blank',
    reboot: 'power_settings_new',
    closedCaption: ccClosedCaptionOn,
    closedCaptionOff: ccClosedCaptionOff,
    talkingGuide: ccTalkingGuideOn,
    talkingGuideOff: ccTalkingGuideOff,
    jobs: 'av_timer',
    file: 'insert_drive_file',
    warning: 'warning',
    add: 'add',
    remove: 'remove',
    tv: 'live_tv',
    help: 'help_outline',
    filter: 'filter_list',
    search: 'search',
    calendar: 'mdi-calendar',
    phone: 'call',
    launch: 'launch',
    question: 'mdi-help',
    expand: 'unfold_more',
    collapse: 'unfold_less',
    vmsAdmin: 'mdi-shield-account',
    mic: 'mic',
    error: 'error_outline'
};
